// extracted by mini-css-extract-plugin
export default {"setting--inverted":"Tgei0Bb","dark-theme":"DIWjYYt","popup":"iqnRLOU","visible":"DghBAJ2","overlay":"R2F9Dtb","overlay__popupCloseButton":"rka3xGR"};